import { useEffect, useState } from "react";

/**
 * Holds a value still until it stops changing.
 *
 * Used for the search boxes: a request per keystroke would put five in flight
 * for "ZNMS " and leave the list showing whichever one happened to land last.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
